export enum DeviceAuthOption {
  ANONYMOUS = "ANONYMOUS",
  USER_LOGIN = "USER_LOGIN",
}
